import {app} from '../../app';

app.service('ShowCloneCodeModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (title, saaspassId, cloneCode) => {
        return $uibModal.open({
            component: 'showCloneCode',
            resolve: {
                title: () => title,
                saaspassId: () => saaspassId,
                cloneCode: () => cloneCode,
            }
        }).result;
    };
    
}



// WEBPACK FOOTER //
// ./src/portal/components/show-clone-code/show-clone-code.modal.js